import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { createGlobalStyle } from "styled-components";
import {
    GoogleTagManager,
    Footer,
    Header,
    HelmetWrapper,
    MOBILE_BREAKPOINT,
    zIndex,
    PageSectionQuoteBranded,
    GutterWrapper,
    PageSectionImage,
    PageSectionVertical
} from "@resourcehub/resourcehub-components";
import "./styles/main.less";

const GlobalStyle = createGlobalStyle`
      body {
        box-sizing: border-box;
        font-family: effra, sans-serif;
        color: #262626;
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 20px;
        overflow-x: hidden;
        overflow-y: scroll;
        background-color: #fff;
      }
      a {
            cursor: pointer;
            text-decoration: none;
            color: inherit;
            &:hover {
                text-decoration: underline;
            }
        }
`;

const OverlayDiv = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: ${zIndex.overlay_main};
    background-color: rgba(33, 33, 33, 0.7);
    opacity: ${(props) => (props.showOverlay ? 1 : 0)};
    pointer-events: ${(props) => (props.showOverlay ? "auto" : "none")};
    transition: all 0.3s;
    @media (max-width: ${MOBILE_BREAKPOINT}) {
        display: none;
    }
`;

class PageWrapper extends Component {
    state = {
        isMobile: false,
        openDropdown: null,
        cartProducts: [],
        cartPrices: [],
        cartCount: 0
    };

    // Lifecycle Methods
    componentDidMount() {
        window.addEventListener("resize", this.resize);
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    render() {
        const { children, config } = this.props;
        const { page } = config;
        const { openDropdown } = this.state;
        return (
            <div>
                <GlobalStyle />
                {page.helmet && <HelmetWrapper {...page.helmet} />}
                {config.nav && (
                    <Header config={config.nav} openDropdown={openDropdown} setOpenDropdown={this.setOpenDropdown} />
                )}
                <OverlayDiv role="menuitem" showOverlay={openDropdown !== null} onClick={this.overlayClick} />
                {children}
                {page.verticals && (
                    <GutterWrapper>
                        <PageSectionVertical {...page.verticals} />
                    </GutterWrapper>
                )}
                {page.awards && (
                    <GutterWrapper>
                        <PageSectionImage {...page.awards} />
                    </GutterWrapper>
                )}
                {page.branded_quotes && (
                    <GutterWrapper>
                        <PageSectionQuoteBranded {...page.branded_quotes} />
                    </GutterWrapper>
                )}
                {config.footer && <Footer config={config.footer} />}
                <GoogleTagManager gtm_id={config.analytics.gtm_id} />
            </div>
        );
    }

    // Custom Methods
    setOpenDropdown = (openDropdown) => {
        this.setState({
            openDropdown: openDropdown
        });
    };

    resize = () => {
        const MOBILE_BREAKPOINT = 1079;
        const { openDropdown, isMobile } = this.state;
        this.setState({
            isMobile: document.body.getBoundingClientRect().width <= MOBILE_BREAKPOINT
        });
        if (!isMobile && openDropdown === "Mobile Nav") {
            this.setState({
                openDropdown: null
            });
        } else if (isMobile && openDropdown === "Languages & Pricing") {
            this.setState({
                openDropdown: null
            });
        }
    };

    overlayClick = () => {
        this.setState({
            openDropdown: null
        });
    };
}

PageWrapper.propTypes = {
    config: PropTypes.object,
    children: PropTypes.node
};

PageWrapper.defaultProps = {
    hedPubSubNav: false
};

export default PageWrapper;
